import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';

import { Google } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';
/**
 *
 * @summary Google impression for View More Vehicles Like This Button
 */
export function viewMoreVehiclesImpression(metadata, option) {
    const { data = {}, state } = metadata;
    const { inventoryId, label = '' } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const listingType = _get(inventory, 'listingType', '').toLowerCase();
    const cmp = `cta::${_kebabCase(label)}`;
    const element = `vdp_${listingType}`;

    Google.sendImpressions(metadata, {
        eventElement: element,
        eventResult: cmp,
        eventData: {
            vehicle: undefined,
        },
    }, option);

    return { cmp, element };
}
